/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsTimecardHist.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-timecard-hist";

export class AutogenModelDrsTimecardHist<RowType extends ModelRow> extends Endpoint<RowType, RowDrsTimecardHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsTimecardHist extends ModelRow<RowDrsTimecardHistFields> {
	constructor(values?: Partial<RowDrsTimecardHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsTimecardHistFields {
	addl_tax_override_hours: number;
	check_date: Date;
	check_number: string;
	company_id: string;
	department: string;
	division_id: string;
	holiday_total: number;
	holiday_total_c: string;
	holiday_total_d: Date;
	holiday_total_n: number;
	holiday_total_r: number;
	holiday_units: number;
	id: string;
	is_void: string;
	job_class_code_id: string;
	overtime_rate: number;
	overtime_total: number;
	overtime_total_c: string;
	overtime_total_d: Date;
	overtime_total_n: number;
	overtime_total_r: number;
	overtime_units: number;
	pay_method: string;
	payee_id: string;
	payment_frequency: string;
	payperiod_end: Date;
	payperiod_start: Date;
	post_key: string;
	post_module: string;
	regular_rate: number;
	regular_total: number;
	regular_total_c: string;
	regular_total_d: Date;
	regular_total_n: number;
	regular_total_r: number;
	regular_units: number;
	sick_total: number;
	sick_total_c: string;
	sick_total_d: Date;
	sick_total_n: number;
	sick_total_r: number;
	sick_units: number;
	terminal_id: string;
	total_hours: number;
	total_pay: number;
	total_pay_c: string;
	total_pay_d: Date;
	total_pay_n: number;
	total_pay_r: number;
	vacation_rate: number;
	vacation_total: number;
	vacation_total_c: string;
	vacation_total_d: Date;
	vacation_total_n: number;
	vacation_total_r: number;
	vacation_units: number;
	void_date: Date;
}

